var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconawesomeLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.076,
    height: 21.076,
    viewBox: "0 0 21.076 21.076",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-linkedin",
    "data-name": "Icon awesome-linkedin",
    d: "M19.571,2.25H1.5A1.512,1.512,0,0,0,0,3.77V21.807a1.512,1.512,0,0,0,1.5,1.52h18.07a1.516,1.516,0,0,0,1.505-1.52V3.77A1.516,1.516,0,0,0,19.571,2.25ZM6.37,20.315H3.246V10.257H6.375V20.315ZM4.808,8.883A1.811,1.811,0,1,1,6.619,7.072,1.812,1.812,0,0,1,4.808,8.883ZM18.079,20.315H14.956V15.423c0-1.167-.024-2.667-1.623-2.667-1.628,0-1.877,1.27-1.877,2.583v4.977H8.332V10.257h3v1.374h.042a3.29,3.29,0,0,1,2.959-1.623c3.161,0,3.749,2.084,3.749,4.794Z",
    transform: "translate(0 -2.25)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomeLinkedin);
export default __webpack_public_path__ + "static/media/Icon awesome-linkedin.c17a86f951b4086fb226968a45feee71.svg";
export { ForwardRef as ReactComponent };